const routes = [
    {
        path: "/admin",
        name: "dashboard",
        component: () =>
            import(
                /* webpackChunkName: 'dashboard' */ "../components/ExampleComponent.vue"
            ),
    },
    {
        path: "/admin/usuarios",
        name: "usuarios",
        component: () =>
            import(
                /* webpackChunkName: 'usuarios' */ "../components/User/UserComponent.vue"
            ),
    },
    {
        path: "/admin/concursos",
        name: "concursos",
        component: () =>
            import(
                /* webpackChunkName: 'concursos' */ "../components/Contest/ContestComponent.vue"
            ),
    },
    {
        path: "/admin/proyectos",
        name: "proyectos",
        component: () =>
            import(
                /* webpackChunkName: 'proyectos' */ "../components/Project/ProjectComponent.vue"
            ),
    },
    {
        path: "/admin/categorias",
        name: "categorias",
        component: () =>
            import(
                /* webpackChunkName: 'categorias' */ "../components/Category/CategoryComponent.vue"
            ),
    },
    {
        path: "/admin/jurados",
        name: "jurados",
        component: () =>
            import(
                /* webpackChunkName: 'jurados' */ "../components/Judge/JudgeComponent.vue"
            ),
    },
    {
        path: "/admin/pre-home",
        name: "",
        component: () =>
            import(
                /* webpackChunkName: 'pre-home' */ "../components/Section/SectionComponent.vue"
            ),
    },
    {
        path: "/admin/novedades",
        name: "novedades",
        component: () =>
            import(
                /* webpackChunkName: 'novedades' */ "../components/Novelty/NoveltyComponent.vue"
            ),
    },
    {
        path: "/admin/terminos",
        name: "terminos",
        component: () =>
            import(
                /* webpackChunkName: 'terminos' */ "../components/Term/TermComponent.vue"
            ),
    },
    {
        path: "/admin/politicas",
        name: "politicas",
        component: () =>
            import(
                /* webpackChunkName: 'politicas' */ "../components/Privacy/PrivacyComponent.vue"
            ),
    },
    {
        path: "/admin/dudas",
        name: "dudas",
        component: () =>
            import(
                /* webpackChunkName: 'dudas' */ "../components/Doubt/DoubtComponent.vue"
            ),
    },
    {
        path: "/admin/t&c",
        name: "t&c",
        component: () =>
            import(
                /* webpackChunkName: 't&c' */ "../components/HabeasData/HabeasDataComponent.vue"
            ),
    },
    {
        path: "/admin/historial-usuario",
        name: "historial-usuario",
        component: () =>
            import(
                /* webpackChunkName: 'historial-usuario' */ "../components/LogUser/LogUserListComponent.vue"
            ),
    },
    {
        path: "/admin/errores-formulario",
        name: "errores-formulario",
        component: () =>
            import(
                /* webpackChunkName: 'errores-formulario' */ "../components/LogFormError/LogFormErrorListComponent.vue"
            ),
    },
    {
        path: "/admin/tratamiento-datos",
        name: "tratamiento-datos",
        component: () =>
            import(
                /* webpackChunkName: 'tratamiento-datos' */ "../components/ChecksLegals/ChecksLegalsComponent.vue"
            ),
    },
    {
        path: "/admin/datos-personales-terceros",
        name: "datos-personales-terceros",
        component: () =>
            import(
                /* webpackChunkName: 'datos-personales-terceros' */ "../components/ChecksAuthorized/ChecksAuthorizedComponent.vue"
            ),
    },
    // {
    //     path: "/:pathMatch(.*)*",
    //     redirect: {
    //         name: "dashboard",
    //     },
    // },
];

export default routes;
